import { Stack } from 'rsuite';
import i18n from 'i18next';
import { jsx as _jsx } from "react/jsx-runtime";
const Brand = props => { return /*#__PURE__*/ _jsx(Stack, Object.assign(Object.assign({ className: "brand" }, props), { children: /*#__PURE__*/ _jsx("span", { children: i18n.t('project.label') }) })); };
export default Brand;
